<template>
    <v-container>
        <v-img
          src="@/assets/initialImage.png"
          aspect-ratio="1.7"
        ></v-img>
    </v-container>
</template>
<script>

    export default{
        mounted:async function(){
            console.log('Home')
        }
    }
</script>